/* 가이드 본문 .huenit 첨부 업로드(dedup) — uploadGuideImage.js 미러.
   파일 바이트의 sha256(hex)을 key 로 써서 같은 바이트면 같은 객체 → 1회만 저장(멱등).
   앱은 이 키의 .huenit 를 내려받아 본문에서 "코드 탭에서 확인하기"로 연다(W145 §계약).
   s3.js 동결 시그니처(putObject)만 사용 → fake/live 동일 동작. */
import { putObject } from '../../api/s3.js';

/* sha256 hex — Web Crypto (uploadGuideImage.js 동형). buffer = ArrayBuffer. */
async function sha256Hex(buffer) {
  const digest = await crypto.subtle.digest('SHA-256', buffer);
  return Array.from(new Uint8Array(digest)).map((b) => b.toString(16).padStart(2, '0')).join('');
}

/* uploadGuideAsset(getCredentials, file) => { key, sha256, bytes }.
   동일 바이트 → 동일 key=dedup(이미지 처리와 동일 규칙), 멱등. */
export async function uploadGuideAsset(getCredentials, file) {
  const buf = await file.arrayBuffer();
  const sha256 = await sha256Hex(buf);
  const bytes = buf.byteLength;
  const key = `official/guide/assets/${sha256}.huenit`;
  await putObject(getCredentials, key, new Uint8Array(buf), 'application/octet-stream');
  return { key, sha256, bytes };
}

export default uploadGuideAsset;
